import { Root } from '@amcharts/amcharts5';
import { XYChart } from '@amcharts/amcharts5/xy';

import { cursor } from 'utils/charts/charts';

export type CursorSettings = {
  cursor: {};
  lineY: {};
  lineX: {};
};

export const setCursor = (root: Root, chart: XYChart, settings: CursorSettings) => {
  const chartCursor = cursor(root, settings.cursor);

  chartCursor.lineY.setAll(settings.lineY);
  chartCursor.lineX.setAll(settings.lineX);
  chart.set('cursor', chartCursor);

  return chartCursor;
};
